// Map panels on Home, one per region the book actually has deals in.
//
// Grouped by coordinates rather than by county or MSA: three active deals carry
// no county at all, but every one is geocoded. Regions are checked in order and
// a deal falls into the first box that holds it, so a box only has to be right
// about the markets we buy in, not about state lines. Anything outside every
// box lands in "Other" rather than stretching a panel across the country.
//
// Florida and Texas used to share one map. The Gulf between them forced the
// zoom out to continent scale and piled every Florida deal into one blob.
export const HOME_MAP_REGIONS = [
  { name: "Florida",   bounds: { latMin: 24.3, latMax: 31.1, lngMin: -87.7,  lngMax: -79.9 } },
  { name: "Texas",     bounds: { latMin: 25.8, latMax: 36.6, lngMin: -106.7, lngMax: -93.5 } },
  { name: "Tennessee", bounds: { latMin: 34.9, latMax: 36.7, lngMin: -90.4,  lngMax: -81.6 } },
];
